import { useState, useEffect } from 'react';
import { useNavigate, Outlet, Link } from 'react-router-dom';
import './AdminPage.css';
import { AdminAuthProvider, useAdminAuth } from './AdminAuthContext';

const AdminPage = () => {
  return (
    <AdminAuthProvider>
      <Outlet />
    </AdminAuthProvider>
  );
};

export default AdminPage;
